import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { GuideTourModule } from "./types";

interface GuideTourState {
  activeModule: GuideTourModule | null;
  isTourActive: boolean;
  currentStepIndex: number;
}

const initialState: GuideTourState = {
  activeModule: null,
  isTourActive: false,
  currentStepIndex: 0,
};

const guideTourSlice = createSlice({
  name: "guideTour",
  initialState,
  reducers: {
    startModuleTour: {
      reducer(
        state,
        action: PayloadAction<{ module: GuideTourModule; stepIndex?: number }>,
      ) {
        state.activeModule = action.payload.module;
        state.isTourActive = true;
        state.currentStepIndex = Math.max(0, action.payload.stepIndex ?? 0);
      },
      prepare(payload: { module: GuideTourModule; stepIndex?: number }) {
        return { payload };
      },
    },
    stopTour(state) {
      state.activeModule = null;
      state.isTourActive = false;
      state.currentStepIndex = 0;
    },
    nextGuideTourStep(state) {
      state.currentStepIndex += 1;
    },
    previousGuideTourStep(state) {
      state.currentStepIndex = Math.max(0, state.currentStepIndex - 1);
    },
    setGuideTourStepIndex(state, action: PayloadAction<number>) {
      state.currentStepIndex = Math.max(0, action.payload);
    },
  },
});

export const {
  nextGuideTourStep,
  previousGuideTourStep,
  setGuideTourStepIndex,
  startModuleTour,
  stopTour,
} = guideTourSlice.actions;

export const guideTourReducer = guideTourSlice.reducer;
